import type { ConfidenceBadge, EmittersData, SystemDetailsData } from './types';

function isHydronicCircuit(circuitType: SystemDetailsData['circuitType']): boolean {
  return circuitType === 'sealed' || circuitType === 'open-vented';
}

export function shouldDefaultEmittersToRadiators(
  circuitType: SystemDetailsData['circuitType'],
  emittersType: EmittersData['emitters'],
): boolean {
  return isHydronicCircuit(circuitType) && emittersType === 'unknown';
}

export function applyEmitterDefault(
  currentEmitters: EmittersData,
  systemDetailsData: SystemDetailsData,
  computeConfidence: (data: EmittersData) => ConfidenceBadge,
): EmittersData {
  if (!shouldDefaultEmittersToRadiators(systemDetailsData.circuitType, currentEmitters.emitters)) {
    return currentEmitters;
  }

  const nextEmitters = {
    ...currentEmitters,
    emitters: 'radiators' as const,
  };

  return {
    ...nextEmitters,
    confidence: computeConfidence(nextEmitters),
  };
}
